module.exports = __webpack_public_path__ + "img/fountain_youth.d51059bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fountain_youth.jpg
// module id = X+/6
// module chunks = 0